export default __webpack_public_path__ + "static/media/ssss.d69998a0.svg";